var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarlogo7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2500 2500",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,1124.9c0-83,51.6-139,149.2-139h633.4v117.7H168.2c-17.2,0-32.5,8.8-32.5,34.8v196.2c0,23.8,10,39.2,41.4,39.2h432.7 c22.8,0,40.4-8.1,40.4-38.1v-45.9H396.9v-112.1h385.7V1358c0,86.3-62.8,133.5-161.4,133.5H150.2C54.9,1491.5,0,1439.9,0,1353.5 L0,1124.9 M1347.6,1491.5L1564,1108v383.5h135.6V985.9H1491L1284.7,1349l-206.3-363.2H869.9v505.6h135.6V1108l216.4,383.5H1347.6  M2500,1491.5h-567.2c-95.5,0-150.2-51.6-150.2-137.9v-228.7c0-83,51.4-139,149-139H2500v127.1h-549.3c-17.2,0-32.6,8.7-32.6,34.7 v177.5c0,23.9,10.1,39.2,41.5,39.2H2500L2500,1491.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarlogo7);
export default __webpack_public_path__ + "static/media/carlogo (7).bfad090680f6e311f8460b4c557cea8b.svg";
export { ForwardRef as ReactComponent };